module.exports = ($el) ->
  selection = window.getSelection()
  string = selection.toString()
  node = selection.anchorNode
  return !!string && !!$el.find(node).length



// WEBPACK FOOTER //
// ./app/scripts/lib/util/selection/has-selection-in.coffee